import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/bulk-import/')({
  beforeLoad: () => {
    throw redirect({ to: '/bulk-import/imports', replace: true });
  },
});
